export default __webpack_public_path__ + "static/media/belt_of_the_doomsayer.49e0620e.jpg";